import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://xgueaskcqbsnhwzvwlbz.supabase.co';
const supabaseAnonKey = 'sb_publishable_8dKxgIICaClDN-vaowLlpA_TYKWDoHc';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
